import { useMemo } from 'react'
import { useAppSelector } from 'hooks/reduxHooks'
import { getOfferListKeyForUser } from 'lib/offer/offerListKey'
import { getCanViewLuxPlusBenefits } from 'luxPlus/selectors/featureToggle'

function useOfferListKey(filters: App.OfferListFilters | undefined): string {
  const canViewLuxPlusBenefits = useAppSelector(getCanViewLuxPlusBenefits)

  return useMemo(
    () => (filters ? getOfferListKeyForUser(filters, canViewLuxPlusBenefits) : ''),
    [filters, canViewLuxPlusBenefits],
  )
}

export default useOfferListKey
